import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Lineup } from "../MainPage/components/Lineup/lineup";
import "./styles.scss";

export const LineupTab = (): JSX.Element => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <div className="lp-wrapper">
      <Lineup />
    </div>
  );
};
